import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import Sidebar from '../Layout/Sidebar';
import { Outlet } from 'react-router-dom';
import { useContext, useEffect,useState } from 'react';
import AuthContext from '../../Contexts/Auth/AuthContext';
import AuthProvider from '../../Contexts/Auth/AuthProvider';

const DashboardNavigation = ({Component}) => {

    const authContext = useContext(AuthContext);
    // console.log('in dashboard navigation component');
    const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };
    return (
        // <div className="bg-gray-900 text-white min-h-screen">
        <div className="bg-gray-900 text-white flex">
            <Sidebar isOpen={sidebarOpen} />
            <div className={`flex-1 ${sidebarOpen ? 'ml-64' : 'ml-0'}`}>
                <Header toggleSidebar={toggleSidebar} />

      {/* <div className="flex">
        <Sidebar isOpen={sidebarOpen} /> */}
        {/* <div className="flex-1 ml-64"> */}
                <Outlet />
        {/* </div> */}
            </div>
        </div>
        // <>
        // <body class="bg-gray-900 text-white m-0 p-0">
        //     {/* <div class="text-white flex min-h-screen"> */}
            
        //     {/* <div class="flex-1 flex flex-col"> */}
        //     <Header />
        //     <div class="flex">
        //     <Sidebar /> 
        //     </div>
        //     {/* <Component/> */}
        //     <Outlet />
        //     {/* </div> */}
        //     {/* <Footer /> */}
        //     {/* </div> */}
        //     </body>
        // </>
    );
}

export default DashboardNavigation;